import { Component, OnInit, OnDestroy, Input, ViewChild, Output, EventEmitter, SimpleChanges, OnChanges, ElementRef } from '@angular/core';
import { VendorService } from 'src/app/services/Vendor.service';
import { GridLine, GridComponent, PageSettingsModel, InfiniteScrollSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { GroupSettingsModel } from '@syncfusion/ej2-angular-grids';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/general.service';
import { ANGULAR_MODULES } from '../shared-imports';
import { LoaderComponent } from '../loader/loader.component';
import { WordReplacePipe } from '../word-replace.pipe';
import { SharedHTMLSettingsDataService } from '../sharedHTMLSettingsData.service';
import { EUserSecurityFunctionID } from '../enum';

@Component({
  selector: 'app-vendor-search',
  templateUrl: './vendor-search.component.html',
  standalone: true,
  imports: [ANGULAR_MODULES, LoaderComponent, WordReplacePipe],
  styleUrls: ['./vendor-search.component.scss']
})
export class VendorSearchComponent implements OnInit, OnDestroy, OnChanges {
  public loaderIcon: Promise<boolean>;
  @Input() FilterData;
  @Input() displayDltBtn;
  public data = [];
  public filterSettings: Object;
  public infiniteOptions: InfiniteScrollSettingsModel;
  public lines: GridLine;
  private subscriptions: Subscription[] = [];
  @Output() vendorSearchRoute = new EventEmitter<any>();
  @Output() openVendorInfoPage = new EventEmitter<any>();
  @ViewChild('grid', { static: false }) public gridData: GridComponent;
  @ViewChild('grid', { static: true }) grid: ElementRef;
  public pageOptions: Object;
  @Input() isVendorListPage: boolean;
  @Input() isVendorPopUp: boolean;
  @Input() VendorFilterOption: any;
  IsLoadAll: boolean = false;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  lastScrollPosition = 0;
  pageNumber = 0;
  VendorFiltersForm: FormGroup;
  response;
  VendorStatusForm: FormGroup;
  SortByDesc = true;
  SortOption = "VendorId";
  AllowSearch = true;
  clientHeight;
  scrollHeight;
  currentScrollPosition = 0.00;
  selectedVendorIds: Set<number> = new Set();
  isAllSelected: boolean = false;
  searchByDLSwipe = false;
  createRight: boolean;
  viewRight: boolean;
  deleteRight: boolean;
  viewRightFalseMessage;
  dLSwipeString = "";
  @Output() vendorSelected = new EventEmitter<any>();
  public ZipCodeMask: String = '00000-0000';
  public PhoneNumberMask: String = '000-000-0000';
  VerifyMandatoryFields = false;

  constructor(private formBuilder: FormBuilder, private vendorService: VendorService, private router: Router, private toastr: ToastrService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private generalService: GeneralService) {

    this.VendorFiltersForm = this.formBuilder.group(
      {
        VendorId: [0],
        MarketVendorId: [''],
        VendorName: [''],
        VendorAddress: [''],
        VendorCompanyName: [''],
        Email: [''],
        VendorState: [''],
        VendorCity: [''],
        VendorZipCode: [''],
        VendorTelephone: [''],
        Product: [''],
        BalanceDue: [0],
        VendorLicenseNumber: [''],
        ResaleNumber: ['']
      });

    this.VendorStatusForm = this.formBuilder.group(
      {
        VendorId: [0, [Validators.required]],
        IsInActive: [false],
        OnHold: [false],
        AutoPay: [false],
      });

    this.VendorFiltersForm.valueChanges
      .pipe(debounceTime(300))
      .subscribe(async searchValue => {

        if (this.AllowSearch == true) {
          this.AllowSearch = false;
          this.loaderIcon = Promise.resolve(true);

          this.data = [];
          this.VendorFilterOption.VendorFilters = this.VendorFiltersForm.value;
          this.pageNumber = 0;
          this.getVendorsByScroll();
        }
      });
  }

  public options?: PageSettingsModel;

  public groupSettings?: GroupSettingsModel = { enableLazyLoading: true };
  VendorNoteVendorSearch;
  ngOnInit(): void {
    this.infiniteOptions = { enableCache: false, initialBlocks: 2 };
    this.filterSettings = { mode: 'Immediate', immediatemodedelay: 100 };
    this.lines = 'Both';
    this.pageOptions = { pageSize: 50 };
    if (this.isVendorListPage == undefined) {
      this.isVendorListPage = false;
    }
    this.deleteRight = this.generalService.getUserPermissionsForModule(EUserSecurityFunctionID['Vendor'])?.DeleteRight ?? false;
  }

  onRowSelect(event: any) {
    const selectedVendor = {
      vendorId: event.VendorId,
      marketVendorId: event.MarketVendorId,
      vendorName: event.VendorName
    };
    this.vendorSelected.emit(selectedVendor);
  }

  extractWords(inputString: string, startCharPosition: number, wordCount: number): string {
    const substring = inputString.substring(startCharPosition);
    const wordsArray = substring.split(/\s+/);
    const extractedWords = wordsArray.slice(0, wordCount);
    return extractedWords.join(' ');
  }

  onCheckboxChange(vendorId: number, event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedVendorIds.add(vendorId);
    } else {
      this.selectedVendorIds.delete(vendorId);
      this.isAllSelected = false;
    }
  }

  selectAll(event?: Event) {
    const checkbox = event?.target as HTMLInputElement;

    if (event) {
      this.isAllSelected = checkbox.checked;
    }
    if (checkbox?.checked || this.isAllSelected) {
      const individualCheckboxes = document.querySelectorAll('input[type="checkbox"][id^="individualCheckbox"]');
      individualCheckboxes.forEach((checkbox) => {
        (checkbox as HTMLInputElement).checked = true;
      });
      this.selectedVendorIds.clear();
      this.data.forEach((item: any) => {
        this.selectedVendorIds.add(item.VendorId);
      });
      this.isAllSelected = true;
    } else {
      const individualCheckboxes = document.querySelectorAll('input[type="checkbox"][id^="individualCheckbox"]');
      individualCheckboxes.forEach((checkbox) => {
        (checkbox as HTMLInputElement).checked = false;
      });
      this.selectedVendorIds.clear();
      this.isAllSelected = false;
    }
  }

  FilterSearch() {
    this.loaderIcon = Promise.resolve(true);
    this.data = [];
    this.VendorFilterOption.VendorFilters = this.VendorFiltersForm.value;
    this.pageNumber = 0;
    this.getVendorsByScroll();
  }

  getFilteredListForInp() {
    this.gridData.clearFiltering();
    if (this.FilterData.vendorDataFilterValue && this.FilterData.vendorDataFilterField)
      this.gridData.filterByColumn(this.FilterData.vendorDataFilterField, 'contains', this.FilterData.vendorDataFilterValue);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.FilterData) {
      this.getFilteredListForInp();
    }

    if (changes.VendorFilterOption && !changes.VendorFilters) {
      this.data = [];
    }

    if (this.isVendorListPage) {
      this.pageNumber = 0;
      this.VendorFilterOption.VendorFilters = this.VendorFiltersForm.value;

      this.VendorFilterOption.SortOption = this.SortOption;
      this.VendorFilterOption.SortByDesc = this.SortByDesc;

      this.getVendorsByScroll();

    } else if (this.isVendorPopUp) {
      this.pageNumber = 0;
      this.VendorFilterOption.VendorFilters = this.VendorFiltersForm.value;

      this.VendorFilterOption.SortOption = "VendorId";
      this.VendorFilterOption.SortByDesc = true;

      this.getVendorsByScroll();
    }
  }

  getVendorsByScroll() {
    this.loaderIcon = Promise.resolve(true);
    this.VendorFilterOption.PageModel.pageCount = this.pageNumber;
    this.subscriptions.push(this.vendorService.getVendorSearchList(this.VendorFilterOption).subscribe((res: any) => {
      if (res) {
        // this.data = [];
        res.map((el, i) => {
          if (this.isVendorPopUp ? !el.Inactive : true) {
            const ob = {
              VendorId: el.VendorId,
              MarketVendorId: el.MarketVendorId,
              VendorName: el.VendorNameFormat != null ? (el.VendorNameFormat
                .replace('<First Name>', (el.VendorFirstName != null ? el.VendorFirstName : ''))
                .replace('<Last Name>', (el.VendorLastName != null ? el.VendorLastName : ''))
                .replace('<Middle Name>', (el.VendorMiddleName != null ? el.VendorMiddleName : ''))).trim()
                .replace(/^, /, '')
                .replace(/^,|,$/g, '') : el.VendorName,
              VendorAddress: el.VendorAddress,
              VendorCompanyName: el.VendorCompanyName,
              Email: el.Email,
              VendorState: el.VendorState,
              VendorCity: el.VendorCity,
              VendorZipCode: el.VendorZipCode,
              VendorTelephone: el.VendorTelephone,
              VendorLicenseNumber: el.VendorLicenseNumber,
              VendorResaleNumber: el.VendorResaleNumber,
              Product: el.Product,
              BalanceDue: el.BalanceDue * -1,
              Inactive: el.Inactive,
              AutoPay: el.AutoPay,
              ResaleNumber: el.ResaleNumber,
              Status: el.Status,
              VendorCommment: el.VendorCommment
            }

            this.data.push(JSON.parse(JSON.stringify(ob)));
          }
        });
      }
      this.AllowSearch = true;
      this.loaderIcon = Promise.resolve(false);
      this.selectAll();
    }));
  }

  ngAfterViewInit() { }

  onGridScroll() {
    let container = this.scrollContainer.nativeElement;
    this.currentScrollPosition = container.scrollTop;
    const containerBottom = container.scrollHeight - container.scrollTop;
    const containerHeight = container.clientHeight;
    if (this.currentScrollPosition > this.lastScrollPosition) {
      if (containerBottom <= containerHeight + 1) {
        this.VendorFilterOption.PageModel.pageCount += 1;
        this.pageNumber += this.VendorFilterOption.PageModel.pageSize;
        this.getVendorsByScroll();
      }
    } else if (this.currentScrollPosition < this.lastScrollPosition) { }
  }


  dataBound(args) {
    Object.assign((<any>this.gridData.filterModule).filterOperators, { startsWith: 'contains' });
  }

  rowSelected(args) {
    this.loaderIcon = Promise.resolve(true);
    const obj = {
      vendorId: args.VendorId,
      marketVendorId: args.MarketVendorId,
      vendorName: args.VendorName,
      VendorCommment: args.VendorCommment
    }

    this.vendorSearchRoute.emit(obj);
    this.loaderIcon = Promise.resolve(false);
  }

  ServerFilter(fieldName: string, event: any) {
    const updatedValue = event.target.value;
    this.VendorFiltersForm.get(fieldName).setValue(updatedValue);
  }

  VendorDetails(i: any, event: MouseEvent): void {
    event.stopPropagation();

    if (this.isVendorPopUp) {
      this.rowSelected(i);
      return;
    }

    const vendorId = i.VendorId;
    const continueToDetails = () => {
      const vendorData = {
        VendorId: vendorId,
        RentalPage: false
      }
      this.openVendorInfoPage.emit(vendorData)
    };
    continueToDetails();
  }

  deleteVendor(i, event: Event) {
    event.stopPropagation();
    Swal.fire({
      title: $localize`Are you sure ?`,
      text: $localize`Deleting vendor, ` + i.VendorName,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.value) {
        this.loaderIcon = Promise.resolve(true);
        this.subscriptions.push(this.vendorService.deleteVendorById(i.VendorId).subscribe((res: any[]) => {
          this.response = res;
          if (this.response.body.Success) {
            this.toastr.success(this.response.body.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            this.loaderIcon = Promise.resolve(false);
          }
          else {
            this.toastr.info(this.response.body.Message, $localize`Info`, this.sharedHTMLSettings.ToasterConfig)
            this.loaderIcon = Promise.resolve(false);
          }
          this.data = [];
          this.pageNumber = 0;
          this.getVendorsByScroll();
        }, (err) => {
          this.toastr.error($localize`Something went wrong delete failed`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
          this.loaderIcon = Promise.resolve(false);
        }));
      }
    });
    this.loaderIcon = Promise.resolve(false);
  }

  openRental(item, event: Event) {
    const vendorId = item.VendorId;
    const vendorData = {
      VendorId: vendorId,
      RentalPage: true
    }
    this.openVendorInfoPage.emit(vendorData)
  }

  resetSearchFields() {

    this.VendorFiltersForm.patchValue({
      VendorId: 0,
      MarketVendorId: '',
      VendorName: '',
      VendorAddress: '',
      VendorCompanyName: '',
      Email: '',
      VendorState: '',
      VendorCity: '',
      VendorZipCode: '',
      VendorTelephone: '',
      Product: '',
      BalanceDue: 0,
      VendorLicenseNumber: '',
      ResaleNumber: ''
    }, { emitEvent: false });

    this.AllowSearch = false;

    this.data = [];
    this.VendorFilterOption.VendorFilters = this.VendorFiltersForm.value;
    this.pageNumber = 0;
    this.getVendorsByScroll();

  }

  SortScrollGrid(option) {
    if (this.SortByDesc) {
      this.VendorFilterOption.SortOption = option;
      this.VendorFilterOption.SortByDesc = false;
      this.loaderIcon = Promise.resolve(true);
      this.data = [];
      this.VendorFilterOption.VendorFilters = this.VendorFiltersForm.value;
      this.pageNumber = 0;
      this.getVendorsByScroll();
      this.SortByDesc = false;
      this.SortOption = option;
    } else {
      this.VendorFilterOption.SortOption = option;
      this.VendorFilterOption.SortByDesc = true;
      this.loaderIcon = Promise.resolve(true);
      this.data = [];
      this.VendorFilterOption.VendorFilters = this.VendorFiltersForm.value;
      this.pageNumber = 0;
      this.getVendorsByScroll();
      this.SortByDesc = true;
      this.SortOption = option;
    }
  }

  ngOnDestroy(): void {
    this.data = [];
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  resetCheckBoxes() {
    this.selectedVendorIds.forEach(el => {
      this.selectedVendorIds.delete(el);
    })
  }
}
